export function OnboardingSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/onboarding.svg'"></ng-include>`
    }
}